import { BaseHubOptions } from "../../BaseHubOptions";

export class BettingOfferManagementHubOptions extends BaseHubOptions {
    name: string = 'BettingOfferHub';
    offerService?: any;
}